export default __webpack_public_path__ + "static/media/dot_active.1fb9162b.svg";